import React, { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  CardMenuHLPure,
  SimpleLoading,
  VerifyContract,
  InformationADAkubicaFirmaDigitalInvitedPure,
  FilterHLPure,
  HeaderHLPure,
  DialogSystemGLPure
} from "../../pures";
import "./contract-request-panel.css";

const ContractRequestPanelView = (props) => {
  const { t } = useTranslation();
  const { dataItem, toggleErrorRequesting, showErrorRequesting, messageError, changeRoute } = props;
  const longmatches = useMediaQuery("(max-width:1200px)");
  const [filterValue, setFilterValue] = useState("");
  const [filteredQuestionnaires, setFilteredQuestionnaires] = useState([]);

  useEffect(() => {
    if (filterValue == "") {
      setFilteredQuestionnaires(props.questionnairesName);
    } else {
      let filtered = props.questionnairesName.filter(q => q.companyId == filterValue)
      setFilteredQuestionnaires(filtered)
    }
  }, [props.questionnairesName, filterValue])


  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
  };

  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  const containerTableAndHeadersStyles = {
    padding: "20px 0px",
    maxWidth: "100%",
    justifyContent: "start",
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const handleSelectedQuestionnaire = (questionnaireId) => {
    let includeState = true
    let state = {
      questionnaireId
    }

    changeRoute('new-contract', includeState, state)
  }

  return (
    <div className="panelStyle-contractRequest">
      {props.loading ? (
        <SimpleLoading />
      ) : props.contractPlanExist ? (
        <div className="contractRequestPanelView-container">
          {props.userType !== 3 ? (
            <div>
              <div className="contractRequest-filter">
                <FilterHLPure
                  options={props.companyFilterOptions}
                  optionsValue={filterValue.toString()}
                  onFilterChange={(e) => setFilterValue(e.target.value)}
                  valueItem={"id"}
                  nameOption={"name"}
                />
              </div>
              <div className="container-cards-contractRequest-view">
                {filteredQuestionnaires.map((item, index) => (
                  <div
                    xs={8}
                    lg={3}
                    md={4}
                    sm={6}
                    className="card-contractRequest"
                  >
                    <CardMenuHLPure {...item} img={item.img} dataItem={item} key={index} onClick={() => handleSelectedQuestionnaire(item.id)} />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="table-card-contractRequest">
              <div className="table-contractRequest">
                <h3 className="table-title-contractRequest">
                  {t("contractRequest.title")}
                </h3>
              </div>
              <div className="container-notification-invited" >
                <div className="btn-notificacions" >
                  <InformationADAkubicaFirmaDigitalInvitedPure
                    onInvitedRedirectRegister={
                      props.onInvitedRedirectRegister
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          {" "}
          <VerifyContract />
        </Container>
      )}
    </div>
  );
};

export { ContractRequestPanelView as default };
